/**
 * 默认忽略转换的字段
 * 会有相同的字段出现在多个接口中，如果确定该字段是不需要转换的，可以加入到该数组中，完成快捷配置，无需在每个接口中配置
 */
export const DEFAULT_IGNORE_TRANSFORM_KEYS = ['media_asset'];
